module.exports = __webpack_public_path__ + "img/excursions.0cf16612.jpg";